var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { style: _vm.cardStyles },
    [
      _c(
        "div",
        {
          staticClass: "d-flex align-items-center",
          staticStyle: { cursor: "pointer" },
          on: { click: _vm.toggleCollapse },
        },
        [
          _vm.faq.avatar
            ? _c("b-avatar", {
                staticClass: "mr-2",
                attrs: {
                  src: _vm.faq.avatar,
                  alt: "Avatar",
                  size: "lg",
                  square: "",
                },
              })
            : _vm._e(),
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-between align-items-center flex-grow-1",
            },
            [
              _c("h3", { staticClass: "mb-0" }, [
                _vm._v(_vm._s(_vm.faq.question)),
              ]),
              !_vm.content_visible
                ? _c("feather-icon", { attrs: { icon: "ChevronDownIcon" } })
                : _c("feather-icon", { attrs: { icon: "ChevronUpIcon" } }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-collapse",
        {
          staticClass: "card-content",
          attrs: { id: _vm.parentID },
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
          model: {
            value: _vm.content_visible,
            callback: function ($$v) {
              _vm.content_visible = $$v
            },
            expression: "content_visible",
          },
        },
        [
          _c(
            "b-row",
            { staticClass: "card-body" },
            _vm._l(_vm.faq.statisticsItems, function (item) {
              return _c(
                "b-col",
                {
                  key: item.icon,
                  staticClass: "mb-2 mb-md-0",
                  class: item.customClass,
                  attrs: { md: "3", sm: "6" },
                },
                [
                  _c(
                    "b-media",
                    { attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-media-aside",
                        { staticClass: "mr-2" },
                        [
                          _c(
                            "b-avatar",
                            { attrs: { size: "48", variant: item.color } },
                            [
                              _c("feather-icon", {
                                attrs: { size: "24", icon: item.icon },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-media-body",
                        { staticClass: "my-auto" },
                        [
                          _c("h4", { staticClass: "font-weight-bolder mb-0" }, [
                            _vm._v(" " + _vm._s(item.title) + " "),
                          ]),
                          _c(
                            "b-card-text",
                            { staticClass: "font-small-3 mb-0" },
                            [_vm._v(" " + _vm._s(item.subtitle) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
          _vm.faq.platform === "facebook"
            ? _c("div", [
                _vm.appid && _vm.appid.length > 0
                  ? _c(
                      "div",
                      [
                        _c("v-facebook-login", {
                          attrs: { "app-id": _vm.firstAppId },
                          on: {
                            "sdk-init": _vm.handleSdkInit,
                            login: _vm.onLogin,
                            logout: _vm.logout,
                          },
                          model: {
                            value: _vm.model,
                            callback: function ($$v) {
                              _vm.model = $$v
                            },
                            expression: "model",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm.faq.platform === "instagram"
            ? _c(
                "div",
                [
                  _vm.instagramAccounts.length > 0
                    ? _vm._l(_vm.media, function (account) {
                        return _c("div", { key: account.id }, [
                          _c("h5", [_vm._v(_vm._s(account.username))]),
                          _c("p", [
                            _vm._v(
                              "Followers: " + _vm._s(account.followers_count)
                            ),
                          ]),
                        ])
                      })
                    : [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-danger",
                            on: { click: _vm.loginWithInstagram },
                          },
                          [_vm._v(" Continue with Instagram ")]
                        ),
                      ],
                ],
                2
              )
            : _vm.faq.platform === "linkedin"
            ? _c("div", [
                _c("button", { staticClass: "btn btn-info" }, [
                  _vm._v("Continue with LinkedIn"),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }